import type { PurchaseOrder } from "@/features/purchase-orders";

export const STATUS_LABELS: Record<PurchaseOrder["status"], string> = {
  draft: "Draft",
  submitted: "Submitted",
  in_production: "In Production",
  ready: "Ready",
  in_transit: "In Transit",
  partially_received: "Partial",
  received: "Received",
  cancelled: "Cancelled",
};

/** Pill background + text colours used for the status select trigger and the
 *  read-only status badge — kept in sync with the colours rendered in
 *  OrdersList so the status reads identically across pages. */
export const STATUS_SELECT_CLASS: Record<PurchaseOrder["status"], string> = {
  draft: "bg-slate-100 text-slate-700 hover:bg-slate-100",
  submitted: "bg-amber-100 text-amber-800 hover:bg-amber-100",
  in_production: "bg-blue-100 text-blue-800 hover:bg-blue-100",
  ready: "bg-violet-100 text-violet-800 hover:bg-violet-100",
  in_transit: "bg-cyan-100 text-cyan-800 hover:bg-cyan-100",
  partially_received: "bg-indigo-100 text-indigo-800 hover:bg-indigo-100",
  received: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
  cancelled: "bg-red-100 text-red-800 hover:bg-red-100",
};
